<app-non-production-banner />
<div class="app-shell">
  @if (showSidebar) {
    <app-sidebar />
  }
  <div class="page-content" [class.page-content--with-sidebar]="showSidebar">
    <router-outlet />
    @if (showFooter) {
    <footer class="site-footer">
      <div class="site-footer-inner" [class.site-footer-inner--centered]="signupFooter">
        <p>{{ footerCopy }}</p>
      </div>
    </footer>
    }
  </div>
</div>
